import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faThumbsUp, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../components/MainHeader/MainHeader.js'
import MainFooter from '../../components/MainFooter/MainFooter.js'
import CTAButton from '../../components/CTAButton/CTAButton.js'

import { lP, boxvar2_1, URL_MAINAPI, API_TOKEN } from '../../main.js'

import '../../main.css'
import './LoginVerification.css'
import './MLoginVerification.css'

import Cookies from 'universal-cookie'
const cookies = new Cookies()

export default function LoginVerification() {

    var [formError, setFormError] = useState(false)
    var eventid;

    useEffect(() => {
        doVerify()
    }, [])

    function doVerify() {
        document.querySelector("#verifyLoading").style.display = "block"
        document.querySelector("#verifyError").style.display = "none"
        document.querySelector("#verifyDone").style.display = "none"

        var urlParams = new URLSearchParams(window.location.search)
        var id = urlParams.get('userid')
        var verifytoken = urlParams.get('verifytoken')
        eventid = urlParams.get('eventid')

        var reqbody = {
            "id": id, "verifytoken": verifytoken
        }

        try {
            fetch(URL_MAINAPI + "/auth/verifylogin", {
                method: "PATCH",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    cookies.set('userid', res.data.userid, { path: '/' })
                    cookies.set('authtoken', res.data.authtoken, { path: '/' })
                    cookies.set('firstname', res.data.firstname, { path: '/' })
                    cookies.set('lastname', res.data.lastname, { path: '/' })
                    document.querySelector("#verifyLoading").style.display = "none"
                    document.querySelector("#verifyDone").style.display = "block"
                    if (res.data.haspassword === false && !res.data.haspasskey) {
                        lP('/profil/sicherheit?migrate=1')
                    } else if (eventid != null && eventid != "0") {
                        lP('/event/' + eventid)
                    } else {
                        lP('/profil')
                    }
                } else {
                    document.querySelector("#verifyLoading").style.display = "none"
                    document.querySelector("#verifyError").style.display = "block"
                }
            }))
        } catch (err) {
            document.querySelector("#verifyLoading").style.display = "none"
            document.querySelector("#verifyError").style.display = "block"
            console.log(err)
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Login wird verifiziert</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body'>
                <div className='auth-wrap'>
                    <div className='auth-head'>
                        <div className='section-eyebrow'>Login-Verifizierung</div>
                        <h1>Du wirst eingeloggt...</h1>
                    </div>

                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card auth-card verify-card' style={{ maxWidth: '480px', margin: '0 auto', textAlign: 'center' }}>
                            <div id="verifyLoading">
                                <h2><FontAwesomeIcon icon={faSpinner} spin style={{ color: 'var(--info)' }} /></h2>
                                <p>Wird geladen... Bitte warten!</p>
                            </div>

                            <div id="verifyError" style={{ display: 'none' }}>
                                <h2><FontAwesomeIcon icon={faTriangleExclamation} style={{ color: 'var(--error)' }} /></h2>
                                <p>
                                    Es gab einen Fehler bei der Verifizierung deines Logins!<br />
                                    Möglicherweise ist der Verifizierungscode ungültig oder dein Konto ist noch nicht aktiviert.<br />
                                    Kontaktiere uns gerne, falls du Hilfe brauchst.
                                </p>
                                <CTAButton variant="primary" title="Login" onclick={() => lP("/login")} />
                            </div>

                            <div id="verifyDone" style={{ display: 'none' }}>
                                <h2><FontAwesomeIcon icon={faThumbsUp} style={{ color: 'var(--success)' }} /></h2>
                                <p>Du bist jetzt eingeloggt!</p>
                                {(eventid != 0 && eventid != null) ? (
                                    <CTAButton variant="secondary" title={"Zum Event"} onclick={() => lP('/event/' + eventid)} />
                                ) : null}
                                <CTAButton variant="secondary" title={"Zum Profil"} onclick={() => lP('/profil')} />
                            </div>
                        </div>
                    </motion.div>
                </div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
